export enum RequestReasons {
  RENONC = "Renonciation client",
  VENTEDEM = "Vente / déménagement",
  DECES = "Décès souscripteur",
  ECHEANCE = "A échéance contrat",
  AUTRE = "Autre motif",
  DEMANDE = "Demande de l’assureur",
  MODIFRISQ = "Modification du risque",
  GDACONF = "GDA confirmé",
  CLIENT = "Client",
  COURTIER = "Courtier",
  DOUBLON = "Doublon",
  IMPAYE = "Impayé",
  HAMON = "Hamon",
  NONE = "NONE",
}
